// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

import {WILDCARD} from '@sdgsystems/vue-common/components/constants'

export function checkPermission (rules, resource, level) {
  var split = resource.split('/')
  for (var i = 0; i < rules.length; i++) {
    if ((rules[i].resourceType === split[0] || rules[i].resourceType === WILDCARD) && rules[i].permissions >= level) { // && !rules[i].fieldsBlackList
      if (rules[i].resourceID === WILDCARD) {
        return true
      } else if (split.length > 1) {
        if (rules[i].resourceID === split[1]) {
          return true
        }
      }
    }
  }
  return false
}

export function checkUserContractor (user, contractor) {
  if (user.securityCtx) {
    return user.securityCtx.companies.includes(contractor)
  }
  return false
}

export function checkUserSite (user, site) {
  if (user.securityCtx) {
    return user.securityCtx.sites.includes(site)
  }
  return false
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@sdgsystems/vue-common/components/user.js
// module id = bG2C
// module chunks = 0